import {Component, computed, effect, inject, input, OnInit} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {NzFormModule} from 'ng-zorro-antd/form';
import {NzInputModule} from 'ng-zorro-antd/input';
import {TranslatePipe} from '@ngx-translate/core';
import {PsdForm} from './psd-form';
import {PsdRulesService} from '../../core/services/psd-rules.service';
import {psdRequirements} from '../psd-requirements';
import {psdValidators} from '../psd-validator';

@Component({
  selector: 'app-psd-fields',
  imports: [
    ReactiveFormsModule,
    NzFormModule,
    NzInputModule,
    TranslatePipe,
  ],
  templateUrl: './psd-fields.html',
})
export class PsdFields implements OnInit {
  readonly form = input.required<PsdForm>();

  private readonly psdRulesService = inject(PsdRulesService);

  readonly rules = this.psdRulesService.rules;
  readonly requirements = computed(() => psdRequirements(this.rules()));

  newPsdVisible = false;
  confirmPsdVisible = false;

  constructor() {
    effect(() => {
      const control = this.form().controls.newPsd;
      control.setValidators(psdValidators(this.rules()));
      control.updateValueAndValidity({emitEvent: false});
    });
  }

  ngOnInit(): void {
    this.psdRulesService.load();
  }
}
